import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Button } from '../components/ui/button';
import { 
  Image, 
  FileText, 
  Users, 
  Zap, 
  DollarSign, 
  MessageSquare, 
  HelpCircle,
  Upload,
  Settings,
  ArrowRight
} from 'lucide-react';
import MediaManager from '../components/admin/MediaManager';
import HeroEditor from '../components/admin/HeroEditor';
import PartnersEditor from '../components/admin/PartnersEditor';
import FeaturesEditor from '../components/admin/FeaturesEditor';
import PricingEditor from '../components/admin/PricingEditor';
import TestimonialsEditor from '../components/admin/TestimonialsEditor';
import FAQEditor from '../components/admin/FAQEditor';
import BackgroundEditor from '../components/admin/BackgroundEditor';

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState('media');

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-8 py-6 sticky top-0 z-50">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold">Admin Panel</h1>
            <p className="text-gray-600 mt-1">Manage your website content</p>
          </div>
          <div className="flex space-x-3">
            <Button 
              onClick={() => window.open('/', '_blank')}
              variant="outline" 
              className="border-gray-300"
            >
              <ArrowRight className="w-4 h-4 mr-2 rotate-180" />
              View Website
            </Button>
            <Button 
              onClick={() => window.location.href = '/'}
              className="bg-pink-500 text-white hover:bg-pink-600"
            >
              Back to Home
            </Button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="px-8 py-8">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-8">
          <TabsList className="bg-white p-2 rounded-xl shadow-sm inline-flex space-x-1">
            <TabsTrigger value="media" className="flex items-center space-x-2 px-4 py-2">
              <Image className="w-4 h-4" />
              <span>Media</span>
            </TabsTrigger>
            <TabsTrigger value="hero" className="flex items-center space-x-2 px-4 py-2">
              <FileText className="w-4 h-4" />
              <span>Hero</span>
            </TabsTrigger>
            <TabsTrigger value="partners" className="flex items-center space-x-2 px-4 py-2">
              <Users className="w-4 h-4" />
              <span>Partners</span>
            </TabsTrigger>
            <TabsTrigger value="features" className="flex items-center space-x-2 px-4 py-2">
              <Zap className="w-4 h-4" />
              <span>Features</span>
            </TabsTrigger>
            <TabsTrigger value="pricing" className="flex items-center space-x-2 px-4 py-2">
              <DollarSign className="w-4 h-4" />
              <span>Pricing</span>
            </TabsTrigger>
            <TabsTrigger value="testimonials" className="flex items-center space-x-2 px-4 py-2">
              <MessageSquare className="w-4 h-4" />
              <span>Testimonials</span>
            </TabsTrigger>
            <TabsTrigger value="faq" className="flex items-center space-x-2 px-4 py-2">
              <HelpCircle className="w-4 h-4" />
              <span>FAQ</span>
            </TabsTrigger>
            <TabsTrigger value="background" className="flex items-center space-x-2 px-4 py-2">
              <Settings className="w-4 h-4" />
              <span>Background</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="media" className="space-y-4">
            <MediaManager />
          </TabsContent>

          <TabsContent value="hero" className="space-y-4">
            <HeroEditor />
          </TabsContent>

          <TabsContent value="partners" className="space-y-4">
            <PartnersEditor />
          </TabsContent>

          <TabsContent value="features" className="space-y-4">
            <FeaturesEditor />
          </TabsContent>

          <TabsContent value="pricing" className="space-y-4">
            <PricingEditor />
          </TabsContent>

          <TabsContent value="testimonials" className="space-y-4">
            <TestimonialsEditor />
          </TabsContent>

          <TabsContent value="faq" className="space-y-4">
            <FAQEditor />
          </TabsContent>

          <TabsContent value="background" className="space-y-4">
            <BackgroundEditor />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default AdminPanel;
